// LikeOutfit likes an outfit on BI
export const OutfitService_LikeOutfitLazy = () =>
  import("./outfit_service.grpc").then((m) => m.OutfitService_LikeOutfit);
OutfitService_LikeOutfitLazy.method =
  "outfits.v1.OutfitService/LikeOutfit" as const;

// UnlikeOutfit unlikes an outfit on BI
export const OutfitService_UnlikeOutfitLazy = () =>
  import("./outfit_service.grpc").then((m) => m.OutfitService_UnlikeOutfit);
OutfitService_UnlikeOutfitLazy.method =
  "outfits.v1.OutfitService/UnlikeOutfit" as const;
